import axios from "axios";
import { BASE_URL } from "../utility/UrlConstants";
import { getHeaderConfig } from "../utility/HeaderConfig";
import { convertObjToQueryString } from "utility/Constant";

  const ECommerce = (filters: Object) => {
    return axios
      .get(`${BASE_URL}/admin/configuration/appconfig/get-config-data?moduleName=${filters}`, getHeaderConfig())
      .then(response => {
        const respData = {
          responseCode: response.status,
          response: response.data
        };
        return respData;
      })
      .catch(error => {
        console.log(error);
        throw error;
      });
  };

  const getCcavenuePaymentLinkData = (requestBody) =>{
    return axios
      .put(`${BASE_URL}/accounts/onlinePayment/get-ccavenue-payment-link`,requestBody, getHeaderConfig())
      .then(response => {
        const respData = {
          responseCode: response.status,
          response: response.data
        };
        return respData;
      })
      .catch(error => {
        console.log(error);
        throw error;
      });

  }

const getPayULinkData = (requestBody) => {
  return axios
    .post(`${BASE_URL}/savingsscheme/chitcustomerpayment/get-onlinepayment-key?${convertObjToQueryString(requestBody)}`, null, getHeaderConfig())
    .then(response => {
      const respData = {
        responseCode: response.status,
        response: response.data
      };
      return respData;
    })
    .catch(error => {
      console.log(error);
      throw error;
    });

}

const paymentOrderStatus = (branchName,rzOrderId) => {
  return axios
    .get(
      `${BASE_URL}/accounts/onlinePayment/get-payu-order-status?branchName=${branchName}&orderDetails=${rzOrderId}`,
      getHeaderConfig()
    )
    .then((response) => {
      const respData = {
        responseCode: response.status,
        response: response.data,
      };
      return respData;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

  const getCcavenueOrderStatusData = (OrderId:Object) => {
    return axios
      .get(`${BASE_URL}/accounts/onlinePayment/get-ccavenue-order-status?orderId=${OrderId}`, getHeaderConfig())
      .then(response => {
        const respData = {
          responseCode: response.status,
          response: response.data
        };
        return respData;
      })
      .catch(error => {
        console.log(error);
        throw error;
      });
  };

  export { ECommerce, getPayULinkData, getCcavenuePaymentLinkData,getCcavenueOrderStatusData, paymentOrderStatus };